import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { PublicAuthRoute } from "./navigation/components/PrivateRoute";
import InvitationLanding from "./features/invitation/pages/InvitationLanding";
import { ROUTES } from "./config/routes";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path={ROUTES.INVITATION}
          element={
            <PublicAuthRoute>
              <InvitationLanding />
            </PublicAuthRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
